import { combineReducers } from "redux";
import devices from "./devices";
import priceRange from "./priceRange";
export default combineReducers({
    devices,
    priceRange,
});
